"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationIconButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cdsCommon = require("@cbhq/cds-common");
var _useButtonVariant2 = require("@cbhq/cds-common/hooks/useButtonVariant");
var _NavigationIcon = require("../icons/NavigationIcon");
var _getFlexStyles = require("../layout/getFlexStyles");
var _focus = require("../styles/focus");
var _Pressable = require("../system/Pressable");
var _linaria = require("../utils/linaria");
var _buttonStyles = require("./buttonStyles");
var _useIconButtonStyles = require("./useIconButtonStyles");
const _excluded = ["active", "as", "compact", "disabled", "name", "onPress", "to", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const flexStyles = (0, _getFlexStyles.getFlexStyles)({
  alignItems: 'center',
  justifyContent: 'center'
});
const NavigationIconButton = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function NavigationIconButton(_ref, ref) {
  let active = _ref.active,
    as = _ref.as,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? true : _ref$compact,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    name = _ref.name,
    onPress = _ref.onPress,
    to = _ref.to,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _useToggler = (0, _cdsCommon.useToggler)(active),
    isActive = _useToggler[0],
    toggleActiveState = _useToggler[1];
  const styles = (0, _useIconButtonStyles.useIconButtonStyles)(compact);
  const _useButtonVariant = (0, _useButtonVariant2.useButtonVariant)(variant,
    // disable transparency
    false),
    backgroundColor = _useButtonVariant.backgroundColor,
    borderColor = _useButtonVariant.borderColor;
  const iconSize = compact ? 's' : 'm';
  const handlePress = (0, _react.useCallback)(event => {
    toggleActiveState.toggleOn();
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
  }, [toggleActiveState, onPress]);
  const handleBlur = (0, _react.useCallback)(() => {
    toggleActiveState.toggleOff();
  }, [toggleActiveState]);
  return /*#__PURE__*/_react.default.createElement(_Pressable.Pressable, _extends({
    noScaleOnPress: true,
    borderColor: borderColor,
    borderRadius: "roundedFull",
    borderWidth: "button",
    onPress: handlePress
  }, props, {
    ref: ref,
    as: as,
    background: backgroundColor,
    className: (0, _linaria.cx)(flexStyles, _buttonStyles.iconButton, isActive ? _focus.focusVisibleClassName : null),
    disabled: disabled,
    onBlur: handleBlur,
    style: styles
  }), /*#__PURE__*/_react.default.createElement(_NavigationIcon.NavigationIcon, {
    name: name,
    size: iconSize
  }));
}));
exports.NavigationIconButton = NavigationIconButton;